import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
import { useSelector } from "react-redux";
import ToastAlert from "../../common/ToastAlert";
import { useState } from "react";
import helper from "../../common/Helper";

const Paypal = ({ stripeSuccess, cartItem }) => {
    const cart = useSelector((state) => state.cart);
    const amount = cartItem?.totalPrice ? cartItem?.totalPrice : cart?.selectedRate?.totalPrice
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const styles = {
        shape: "pill",
        layout: "vertical",
    };

    const handlePayPalError = (err) => {
        let errorMessage = "An unknown error occurred.";
        if (err?.message) {
            errorMessage = err.message;
        }

        if (err?.name === "INSTRUMENT_DECLINED") {
            errorMessage = "Your payment method was declined. Please try another payment method.";
        } else if (err?.name === "PAYER_ACTION_REQUIRED") {
            errorMessage = "Additional action is required for this payment.";
        } else if (err?.name === "TRANSACTION_REJECTED") {
            errorMessage = "Transaction was rejected by PayPal.";
        } else if (err?.name === "INSUFFICIENT_FUNDS") {
            errorMessage = "You have insufficient funds for this transaction.";
        }
        ToastAlert({ msg: errorMessage, msgType: "error" });

    };

    const checkboxChangeHandler = () => {
        if (!isCheckboxChecked) {
            setIsCheckboxChecked(!isCheckboxChecked)
        }
    }
    const onClick = () => {
        if (!isCheckboxChecked) {
            ToastAlert({ msg: "Please check terms & condition", msgType: "error" });
            return false;
        }
    }
    // console.log(helper.paypalClientId);


    return (
        <>
            <PayPalScriptProvider options={{ "client-id": helper.paypalClientId, currency: "EUR" }}>
                <PayPalButtons
                    onClick={onClick}
                    // disabled={!isCheckboxChecked}
                    style={styles}

                    fundingSource={undefined}  // Ensure all buttons show

                    createOrder={(data, actions) => {
                        return actions.order.create({
                            intent: "CAPTURE",
                            purchase_units: [{ amount: { currency_code: "EUR", value: Number(amount) } }]

                        });
                    }}

                    onCancel={(data) => {
                        console.log("PayPal Payment Cancelled: ", data);
                    }}

                    onApprove={(data, actions) => {
                        return actions.order.capture().then(async (details) => {
                            let res = {}
                            res.transaction_details = details
                            // res.transaction_id = details?.id
                            res.transaction_id = details?.purchase_units[0]?.payments?.captures[0]?.id
                            await stripeSuccess(res)
                        });
                    }}

                    onError={(err) => {
                        handlePayPalError(err);
                    }}
                />
            </PayPalScriptProvider>
            <div className="checkAndGo">
                <div className="tandcMainDiv">
                    <div className="clickTo" onClick={() => checkboxChangeHandler()}>
                        <input type="checkbox"
                            checked={isCheckboxChecked}
                            disabled={isCheckboxChecked}
                            className="keyword-checkbox" />

                        <label htmlFor="" className="keyword-label" style={{ cursor: "pointer" }}>I have read and agree to the website </label>
                    </div>
                    <a target="_blank" className="tandcLink" href="/terms-and-conditions"> terms and conditions</a>
                </div>
            </div>
        </>
    )
}
export default Paypal